import { gql } from '@apollo/client';

export const CursorPageInfoFragment = gql`
  fragment CursorPageInfo on PageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
`;
